/*
 * Canonical property URL construction shared by every property-link consumer.
 * The rule lives in api/site-urls.cjs so the sitemap job lists exactly the URL each page serves:
 * missing addresses use MLS IDs, absent parts are omitted, and boundary hyphens are trimmed.
 */
import siteUrls from '../api/site-urls.cjs';

type PropertyLinkData = {
  id: string | number;
  mls_id?: string | number | null;
  address?: string | null;
  city?: string | null;
  province?: string | null;
  postal_code?: string | null;
};

export const getPropertyLink = function (property: PropertyLinkData, language: string | null = null): string {
  return siteUrls.propertyPath(property, language);
};
